import { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

function HomePage(){
    return(
        <div>

        <h1>About Me</h1>
        <p>Computer Science student, interests include Web Development, Databases, Machine Learning, and Bioinformatics.</p>
        <p>Software and Hardware Quality Professional on the Seattle East Side, with over 15 years of expereince in the BioTech and MedDev fields</p>
        

        <h1>Education</h1>

        <h2>Oregon State University</h2>
        <h3>Bachelor of Science, 2010</h3>
        <ul>
        <li>Biology Major, Chemistry Minor</li>
        <li>Acheivemnts and Activities: Division 1 Rower, Dean's List, AP Scholar</li>
        </ul>

        <h2>Oregon State University</h2>
        <h3>Bachelor of Science, Anticipated Graduation 2027</h3>
        <ul>
        <li>Computer Science Major</li>
        <li>Completed Coursework: Data Structures, Web Development, Databases</li>
        <li>Technologies: Python, JavaScript, C++, React, Flask</li>
        </ul>

        <h1>Certifications</h1>
        <img src= "/CSQE.png" alt = "Certified Software Quality Engineer Badge"></img> <img src= "/CQE.png" alt = "Certified Quality Engineer Badge"></img>
      
      <h1>Professional Experience</h1>

      <h2>Phillips Healthcare</h2>
      <h3>Bothell, WA 2019-Present</h3>
      <h3>Senior Product Quality Engineer</h3>
     
        <p>As a medical device quality engineer at Philips, I worked on software, hardware, and accessories for AEDs. I collaborated with several cross functional teams to ensure our hardware and software products were safe, effective, and met rigorous regulatory standards. I provided technical guidance throughout the product lifecycle, contributed to risk analysis and problem-solving, and supported the integration of quality practices into software development. My experience includes analyzing data to improve processes, managing complex documentation, and leading continuous improvement efforts—all while working in fast-paced, highly regulated environments.</p>

      <h2>Bio-Rad Laboratories, Inc</h2>
      <h3>Woodinville, WA 2016-209</h3>
      <h3>Quality Engineer</h3>
      <p>
As a quality engineer at Bio-Rad, I worked on in vitro diagnostics manufacturing and support. I led key initiatives to validate software, equipment, and processes, ensuring our work met strict FDA and ISO standards. I managed risk assessments and used tools like FMEA to proactively address potential issues throughout the product lifecycle. My experience includes supporting software validation for automated diagnostic equipment, conducting engineering investigations, and driving process improvements—such as a Six Sigma Green Belt project that significantly reduced waste and customer complaints. I also designed measurement system analyses to maintain accuracy and consistency in production and quality control.
</p>
      
    </div>
    );

}



export default HomePage; 